<template>
  <div
    v-if="
      clientServices.length != dynamicClientServicesCountDisplay ||
        (clientServices.length == dynamicClientServicesCountDisplay &&
          loadFromDymamicServices)
    "
    :class="{ 'latest-file-cards': true, vertical: loadFromDymamicServices }"
  >
    <latest-file-card-item
      :file="latestEligibilityFile"
      fileText="Eligibilty Data"
    />
    <latest-file-card-item
      :file="latestIncentiveFile"
      fileText="Incentive Points"
    />
    <latest-file-card-item
      :file="latestBiometricFile"
      fileText="Biometrics Points"
    />
  </div>
</template>
<script>
import LatestFileCardItem from "@/components/dashboard/LatestFileCardItem";
import { mapGetters, mapActions } from "vuex";
import consts from "../../_consts";
import {
  GETTERS_LATEST_ELIGIBILITY_FILE,
  GETTERS_LATEST_BIOMETRIC_FILE,
  GETTERS_LATEST_INCENTIVE_FILE,
  ACTION_GET_LATEST_FILE
} from "../../store/modules/files_processing/constants";
import { GETTERS_CLIENT_SERVICES_CONFIGURATION } from "../../store/modules/users/constants";
export default {
  name: "latest-file-cards",
  components: {
    LatestFileCardItem
  },
  props: {
    loadFromDymamicServices: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dynamicClientServicesCountDisplay: 2
    };
  },
  beforeMount() {
    let clientIdStr = '';
    if (localStorage.client) {
      clientIdStr = ";client_id:" + JSON.parse(localStorage.client).id;
    }
    this.getLatestFileAction({
      params: {
        search: "data_type:" + consts.uploadFileType.incentive + clientIdStr,
        searchJoin: "and",
        orderBy: "upload_date",
        sortedBy: "desc",
        limit: 1
      },
      file_type: consts.uploadFileType.incentive
    });
    this.getLatestFileAction({
      params: {
        search: "data_type:" + consts.uploadFileType.eligibility + clientIdStr,
        searchJoin: "and",
        orderBy: "upload_date",
        sortedBy: "desc",
        limit: 1
      },
      file_type: consts.uploadFileType.eligibility
    });
    this.getLatestFileAction({
      params: {
        search: "data_type:" + consts.uploadFileType.biometrics + clientIdStr,
        searchJoin: "and",
        orderBy: "upload_date",
        sortedBy: "desc",
        limit: 1
      },
      file_type: consts.uploadFileType.biometrics
    });
  },
  methods: {
    ...mapActions({
      getLatestFileAction: ACTION_GET_LATEST_FILE
    })
  },
  computed: {
    latestEligibilityFile() {
      return this.getLatestEligibilityFile;
    },
    latestBiometricFile() {
      return this.getLatestBiometricFile;
    },
    latestIncentiveFile() {
      return this.getLatestIncentiveFile;
    },
    clientServices() {
      return this.getClientServices;
    },
    ...mapGetters({
      getLatestEligibilityFile: GETTERS_LATEST_ELIGIBILITY_FILE,
      getLatestBiometricFile: GETTERS_LATEST_BIOMETRIC_FILE,
      getLatestIncentiveFile: GETTERS_LATEST_INCENTIVE_FILE,
      getClientServices: GETTERS_CLIENT_SERVICES_CONFIGURATION
    })
  }
};
</script>
<style lang="scss">
@import "~@/assets/styles/_core-variables.scss";
.latest-file-cards {
  overflow: hidden;
  padding-top: 2px;
  padding-bottom: 5px;
  margin-bottom: 20px;
  &.vertical .latest-file-card {
    margin-right: 0;
    margin-bottom: 20px;
    clear: both;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .latest-file-card {
    float: left;
    position: relative;
    width: 270px;
    border-radius: 4px;
    box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2), 0 2px 1px 1px rgba(0, 0, 0, 0.1);
    margin-right: 25px;
    margin-bottom: 15px;
    &:last-child {
      margin-right: 0;
    }
    &__status {
      i {
        &:before {
          display: inline-block;
          content: " ";
          height: 37px;
          width: 37px;
          position: absolute;
          left: 13px;
          top: 25px;
        }
      }
    }
    &__info {
      margin-left: 62px;
      background-color: $white;
      height: 90px;
      font-size: 12px;
      line-height: 17px;
      padding-top: 15px;
      padding-left: 30px;
      &-file {
        font-weight: 700;
        font-size: 15px;
      }
      &-date {
        color: $light-grey;
      }
      &-status {
        color: $cl-primary;
      }
    }
    &.completed {
      background-color: $green;
      .latest-file-card__status i:before {
        background: url("../../assets/icons/icon-completed-large.svg") no-repeat;
      }
    }
    &.completed-error {
      background-color: $yellow;
      .latest-file-card__status i:before {
        background: url("../../assets/icons/icon-completed-error-large.svg")
          no-repeat;
      }
    }
    &.failed {
      background-color: $cl-danger;
      .latest-file-card__status i:before {
        background: url("../../assets/icons/icon-failed-large.svg") no-repeat;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/LatestFileCards.vue